import { appConfig } from 'cd-eft/config/AppConfig';
import axios from 'axios';
import { AppConstants } from 'cd-eft/appConstants';

export const getFpacFeatureFlags = async () => {

    try {
        const params = new URLSearchParams();
        params.append('appId', AppConstants.fpacAppGUID);
        params.append('environment', appConfig.ffsEnvironmentName);
        params.append('appVersion', appConfig.releaseVersion);
        const baseUrl = appConfig.endpoints.fpacFFSBasePath;
        const response = await axios.get(baseUrl + '?' + params.toString());
        return response;
    }
    catch (error) {
        console.error(error);
    }
}